// src/game/skills.js
// getAffectedPositions(grid, monsterId, r, c) -> [{r,c}...]

export function getAffectedPositions(grid, monsterId, r, c) {
  const rows = grid.length;
  const cols = grid[0]?.length ?? 0;

  const out = [];
  const add = (rr, cc) => {
    if (rr < 0 || rr >= rows || cc < 0 || cc >= cols) return;
    out.push({ r: rr, c: cc });
  };

  const uniq = (arr) => {
    const set = new Set();
    const res = [];
    for (const p of arr) {
      const k = `${p.r},${p.c}`;
      if (!set.has(k)) { set.add(k); res.push(p); }
    }
    return res;
  };

  const tileAt = (rr, cc) => grid?.[rr]?.[cc];

  // ✅ Aliases para não voltares a quebrar quando mudares nomes
  // terra = terramoto
  if (monsterId === "terra") monsterId = "terramoto";
  // fogo = (skill própria)
  // (mantemos "fogo" como fogo)

  // --- RAIO: cruz ---
  if (monsterId === "raio") {
    for (let cc = 0; cc < cols; cc++) add(r, cc);
    for (let rr = 0; rr < rows; rr++) add(rr, c);
    return uniq(out);
  }

  // --- JATO: coluna ---
  if (monsterId === "jato") {
    for (let rr = 0; rr < rows; rr++) add(rr, c);
    return uniq(out);
  }

  // --- CONTROLO: limpa toda a cor do tile alvo ---
  if (monsterId === "controlo") {
    const t = tileAt(r, c);
    if (!t) return [];
    const color = t.color;
    for (let rr = 0; rr < rows; rr++) {
      for (let cc = 0; cc < cols; cc++) {
        const tt = tileAt(rr, cc);
        if (tt && tt.color === color) add(rr, cc);
      }
    }
    return uniq(out);
  }

  // --- FOGO: explosão 3x3 centrada no alvo ---
  if (monsterId === "fogo") {
    for (let rr = r - 1; rr <= r + 1; rr++) {
      for (let cc = c - 1; cc <= c + 1; cc++) {
        add(rr, cc);
      }
    }
    return uniq(out);
  }

  // --- TURBILHÃO: “diamante” raio 2 ---
  if (monsterId === "turbilhao") {
    const radius = 2;
    for (let dr = -radius; dr <= radius; dr++) {
      for (let dc = -radius; dc <= radius; dc++) {
        if (Math.abs(dr) + Math.abs(dc) <= radius) add(r + dr, c + dc);
      }
    }
    return uniq(out);
  }

  // --- TERRAMOTO: duas linhas de baixo (sem alvo) OU linha do alvo ---
  // Como estamos a chamar com alvo, vamos limpar 2 linhas de baixo sempre:
  if (monsterId === "terramoto") {
    const bottom1 = rows - 1;
    const bottom2 = rows - 2;
    for (let cc = 0; cc < cols; cc++) add(bottom1, cc);
    for (let cc = 0; cc < cols; cc++) add(bottom2, cc);
    return uniq(out);
  }

  return [];
}